export default __webpack_public_path__ + "static/media/bcg-union@2x.f3bee952.png";